import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import MyCard from './../MyCard.js';
import Cardto from './../Cardto.js';


class Exam3eme extends React.Component{
  render(){
    return(
      <div>
          <Alert variant="dark">
            <h3>
              Examen des maths + correction (PDF) pour tous les nivaux
            </h3>
          </Alert>
          <Row>
              <Cardto
                title="Examen régional pour le 3ème année secondaire"
                ty="Examen"
                color1="#00e68a"
                linkto="/maths/3-eme/regional/examen" />

              <Cardto
                title="Examen locale pour le 3ème année secondaire"
                ty="Examen"
                color1="#00e68a"
                linkto="/maths/3-eme/locale/examen" />
          </Row>

      </div>
    );
  }
}

export default Exam3eme ;
